module.exports = __webpack_public_path__ + "static/img/VA@2x.52a9d27c.jpg";